import {ID, Response} from '../../../../../_metronic/helpers'

// export type User = {
//   code?: ID
//   firstName?: string
//   avatar?: string
//   email?: string
//   position?: string
//   role?: string
//   lastLoginDate?: string
//   two_steps?: boolean
//   join_date?: string
//   online?: boolean
//   lastName?: string
//   address?: string
//   niC_no?: string
//   lockoutEnabled?: boolean
//   designation?: string
//   phoneNumber?: string
//   accountStatus?:string
//   fK_Country?:string
//   fK_Gender?:string
//   fK_Customer?:number
//   fK_Location?:string
//   city?:string
//   isConfirmed?:boolean
//   isNewPasswordGenerate?:boolean
//   userType?:string
//   initials?: {
//     label: string
//     state: string
//   }
// }
interface Feature {
  id: number;
  code: string;
  name: string;
}

interface UserFeature {
  id: number;
  fK_User: string;
  featureId: number;
  feature: Feature;
}

interface UserSubcustomer {
  code: number;
  name: string;
}

interface UserCustomerAccess {
  code: number;
  name: string;
}

export type User = {
  customerAccess?: UserCustomerAccess[]
  customerIds?: any[]
  code?: ID
  terpId?: string
  userId?: string
  avatar?: string
  lastLoginDate?: string
  accountStatus?: string
  lockoutEnabled?: boolean
  recieveAllEmails?: boolean
  recieveUserEmails?: boolean
  join_date?: string
  firstName?: string
  lastName?: string
  email?: string
  role?: string
  accessBilling?: boolean
  setPassword?: boolean
  phoneNumber?: string
  password?: string | null
  modifiedBy?: null
  modifiedDateTime?: string
  niC_no?: null
  address?: string
  designation?: null
  isdeleted?: boolean
  edit_By?: null
  delete_By?: null
  edit_Date?: string
  delete_Date?: null
  userType?: string
  fK_Customer?: string
  fK_Gender?: string
  position?: string
  contryName?: string
  customerName?: string
  accountLevel?: string
  officeLocation?: string
  fK_Location?: string
  fK_PreCallPolicy?: string
  fK_ServiceType?: string
  defaultTimeZone?: string
  fK_DefaultTimeZone?: string
  fK_DefaultNativeLanguage?: string
  city?: string
  street1?: string
  street2?: string
  state?: string
  postalCode?: string
  serviceType?: string
  defaultLanguage?: string
  profileImage?: string
  profileImageFile?: File
  isNewPasswordGenerate?: boolean
  isConfirmed?: boolean
  opI_ShdTelephonic?: boolean
  opI_OndemandTelephonic?: boolean

  vrI_ShdVideoInteroreting?: boolean
  vrI_OndemandVideoInteroreting?: boolean

  osI_OnsiteConsecutive?: boolean
  osI_OnsiteSimultaneous?: boolean
  osI_OnsiteWhisper?: boolean
  osI_Onsite?: boolean
  other_3rdPartyPlatform?: boolean
  translations?: boolean
  pinCode?: number | string
  pinCodeString?: string
  latitude?: string
  longitude?: string
  country?: string
  serviceTypes?: any,
  secondaryOpiServiceTypes?: { value: string; label: string }[],
  userFeatures?: UserFeature[];
  requesterSubcustomrs?: UserSubcustomer[];
  linguistType?: number
  payableType?: number
  isAllowedMobileLogin?: boolean
}
export type CustomDictionaryModel = {
  key?: string
  value?: string
}

export type UserRole = {
  id?: string
  name?: string
  normalizedName?: string
  status: string
  userId?: string
  userName?: string
}

export type Deletemodel = {
  email?: string
  code?: string
}

export type UsersQueryResponse = Response<Array<User>>
export type RolesQueryResponse = Response<Array<UserRole>>
export type DropdownResponse = Response<Array<CustomDictionaryModel>>

export type UserEditModalLookups = {
  officeLocations?: CustomDictionaryModel[]
  subAccounts?: {code: number; name: string; parentCustomerId: number}[]
  customerServiceTypes?: CustomDictionaryModel[]
  preCallPolicies?: {key?: string; value?: string; label?: string}[]
}

export type UserEditModalDataResponse = {
  user: User
  lookups?: UserEditModalLookups
}

export const initialUser: User = {
  position: 'Art Director',
  role: '',
  firstName: '',
  email: '',
  lastName: '',
  isNewPasswordGenerate: true,
  pinCode: undefined,
  address: '',
  serviceTypes: [],
  secondaryOpiServiceTypes: [],
  fK_Customer: '',
  userType : 'CONSUMER',
  password: null,
  linguistType: 0, // Default: Interpreter
  payableType: 0, // Default: Hourly
  isAllowedMobileLogin: false,
}
